/**
 * @import { PlaceInfo } from '@/features/world-map/types/place-info'
 */

import { createContext, useContext } from 'react';

/**
 * @typedef {object} PlaceInfoContext
 * @property {PlaceInfo | null} placeInfo
 * @property {React.Dispatch<React.SetStateAction<PlaceInfo | null>>} setPlaceInfo
 */

/** @type {React.Context<PlaceInfoContext>} */
// @ts-ignore
export const PlaceInfoContext = createContext(null);

export const usePlaceInfoContext = () => useContext(PlaceInfoContext);
